import script from "./RefreshAccessToken.vue?vue&type=script&setup=true&lang=ts"
export * from "./RefreshAccessToken.vue?vue&type=script&setup=true&lang=ts"

import "./RefreshAccessToken.vue?vue&type=style&index=0&id=474f9922&lang=css"

const __exports__ = script;

export default __exports__